import { getObservability } from '@personal-trainer-app/shared';
import { ObservabilitySeverity } from '@personal-trainer-app/shared/src/types/observability';

import type { ErrorInfo } from 'react';

/**
 * Report an error an error boundary caught, through the shared observability
 * manager (Sentry on web; scrubbed before it's sent). The component stack goes
 * with it as context, since a boundary is the only place React hands it over.
 *
 * Boundaries report here rather than through React 19's `onCaughtError` root
 * hook, which is deliberately not wired, so each error is reported once.
 */
export function reportBoundaryError(
  error: Error,
  errorInfo: ErrorInfo,
  boundary: string
): void {
  getObservability().captureError(
    error,
    ObservabilitySeverity.ERROR,
    { boundary, componentStack: errorInfo.componentStack ?? undefined },
    { boundary }
  );
}
